"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

/*

    Created a wrapper around Autosuggest to over ride some default functionality

*/
var AutoSuggestWrapper = /*#__PURE__*/function (_Autosuggest) {
  (0, _inheritsLoose2.default)(AutoSuggestWrapper, _Autosuggest);
  function AutoSuggestWrapper() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Autosuggest.call.apply(_Autosuggest, [this].concat(args)) || this;
    _this.onDocumentMouseDown = function (event) {
      _this.justClickedOnSuggestionsContainer = false;
      var target = event.detail.target;
      var node = target || (event == null ? void 0 : event.target);
      while (node !== null && node !== document) {
        var _node, _node2, _node3, _node4;
        if ((_node = node) != null && _node.getAttribute && ((_node2 = node) == null ? void 0 : _node2.getAttribute('data-suggestion-index')) !== null) {
          // Suggestion was clicked
          return;
        }
        if ((_node3 = node) != null && _node3.getAttribute && ((_node4 = node) == null ? void 0 : _node4.getAttribute('class')) === 'overlay-container') {
          // overlay was clicked
          _this.justSelectedSuggestion = false;
          return;
        }
        if (node === _this.suggestionsContainer) {
          // Something else inside suggestions container was clicked
          _this.justSelectedSuggestion = true;
          return;
        }
        node = node.parentNode;
      }
    };
    return _this;
  }
  return AutoSuggestWrapper;
}(_reactAutosuggest.default);
var _default = AutoSuggestWrapper;
exports.default = _default;
module.exports = exports["default"];